import React, { FC } from 'react';
import { Create, SimpleForm, useCreatePath, useNotify, useRedirect } from 'react-admin';
import { Typography, Container } from '@mui/material';
import { palette } from '../../../Theme';
import ShsFormToolbar from 'src/components/common/ShsFormToolbar';
import { SpecialServiceInputsCard } from '../common/SpecialServiceInputsCard';
import { ShsReturnButton, ShsSuccessNotification } from 'src/components/common';
import { NOTIFICATION_OPTIONS_SUCCESS, Resource } from 'src/constants';

export const CreateSpecialService: FC = () => {
    const redirect = useRedirect();
    const createPath = useCreatePath();
    const notify = useNotify();

    const handleCancelBtnClick = () => {
        redirect(createPath({ resource: Resource.SPECIAL_SERVICES, type: 'list' }));
    };

    const transform = (data: any) => ({
        ...data,
        name: data.name.trim()
    });

    return (
        <Container>
            <ShsReturnButton
                to={createPath({ resource: Resource.SPECIAL_SERVICES, type: 'list' })}
                label="Назад до спеціальних послуг"
                sx={{ color: palette.primary.grayBluish }}
            />
            <Typography fontSize={40} fontWeight={700} sx={{ mb: 3 }}>
                Додати послугу
            </Typography>

            <Create
                mutationOptions={{
                    onSuccess: () => {
                        notify(
                            <ShsSuccessNotification message="Послугу успішно додано" />,
                            NOTIFICATION_OPTIONS_SUCCESS
                        );
                        redirect('list', Resource.SPECIAL_SERVICES);
                    }
                }}
                transform={transform}
                sx={{ '.RaCreate-card': { backgroundColor: 'transparent', boxShadow: 'none' } }}>
                <SimpleForm toolbar={false} mode="onBlur" sx={{ padding: 0 }}>
                    <SpecialServiceInputsCard />
                    <ShsFormToolbar submitLabel="Додати послугу" handleCancel={handleCancelBtnClick} />
                </SimpleForm>
            </Create>
        </Container>
    );
};
